import React, { useState } from 'react';
import { FaRobot, FaUser } from 'react-icons/fa';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';

const ChatAssistant = () => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [isTyping, setIsTyping] = useState(false);

  const handleSendMessage = async () => {
    if (input.trim() === '') return;

    const userMessage = { text: input, sender: 'user' };
    setMessages(prevMessages => [...prevMessages, userMessage]);
    setInput('');
    setIsTyping(true);

    try {
      const response = await axios.post('https://api.openai.com/v1/chat/completions', {
        model: "gpt-3.5-turbo",
        messages: [{ role: "user", content: input }],
      }, {
        headers: {
          'Authorization': `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`,
          'Content-Type': 'application/json'
        }
      });

      const botMessage = { text: response.data.choices[0].message.content, sender: 'bot' };
      setMessages(prevMessages => [...prevMessages, botMessage]);
    } catch (error) {
      console.error('Error sending message:', error);
      toast.error('Error al enviar el mensaje. Por favor, intenta de nuevo.');
    } finally {
      setIsTyping(false);
    }
  };

  return (
    <div className="chat-container bg-white rounded-lg shadow-lg p-6 max-w-2xl mx-auto">
      <ToastContainer />
      <h2 className="text-3xl font-bold mb-6 text-gray-800 flex items-center justify-center">
        <FaRobot className="mr-2 text-blue-500" />
        Asistente de Construcción
      </h2>
      <div className="chat-messages flex-grow overflow-auto mb-4 h-96 border border-gray-200 rounded-lg p-4">
        {messages.map((message, index) => (
          <div 
            key={index} 
            className={`message ${message.sender} mb-4 flex ${message.sender === 'user' ? 'justify-end' : 'justify-start'}`}
          >
            <div className={`max-w-3/4 p-3 rounded-lg ${message.sender === 'user' ? 'bg-blue-100 text-right' : 'bg-gray-100'}`}>
              <div className="flex items-center mb-1">
                {message.sender === 'user' ? (
                  <>
                    <span className="font-semibold mr-2">Tú</span>
                    <FaUser className="text-blue-500" />
                  </>
                ) : (
                  <>
                    <FaRobot className="text-green-500 mr-2" />
                    <span className="font-semibold">Asistente</span>
                  </>
                )}
              </div>
              <p className="text-sm">{message.text}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="flex">
        <input
          type="text"
          className="flex-grow p-3 border rounded-l-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Escribe tu mensaje..."
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
          disabled={isTyping}
        />
        <button
          className="bg-blue-500 text-white p-3 rounded-r-lg hover:bg-blue-600 transition duration-300"
          onClick={handleSendMessage}
          disabled={isTyping}
        >
          Enviar
        </button>
      </div>
      {isTyping && (
        <div className="text-gray-500 text-sm mt-2">El asistente está escribiendo...</div>
      )}
    </div>
  );
};

export default ChatAssistant;
